import { render } from "./StudyProgramForm.vue?vue&type=template&id=64d571d6&scoped=true"
import script from "./StudyProgramForm.vue?vue&type=script&lang=js"
export * from "./StudyProgramForm.vue?vue&type=script&lang=js"

import "../css/UniversityForm.css?vue&type=style&index=0&id=64d571d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d571d6"]])

export default __exports__